import { Comparator } from "../interface/type/comparator.type";
import { Optional } from "./optional.model";

	/**
	 * @description
	 *	Algoritmos relevantes y genéricos.
	 */

export class Algorithm {

    private constructor() {
        throw new Error(
            "Nunca debe instanciar o heredar de esta clase (es de soporte).");
    }

	/**
	 * @description
	 *	Realiza una búsqueda binaria sobre un vector, suponiendo que el mismo
	 *	se encuentra ordenado de forma ascendente con respecto a la clave de
	 *	búsqueda.
	 *
	 *	Esta implementación particular aplica el "Algoritmo de Bottenbruch".
	 *
	 * @param array
	 *	El vector sobre el cual buscar.
	 *
	 * @param key
	 *	La clave a buscar.
	 *
	 * @param comparator
	 *	El comparador con el cual realizar la búsqueda. Nótese que el mismo
	 *	puede incluir un extrator de clave en su interior.
	 *
	 * @returns
	 *	Un opcional con el resultado hallado.
	 */
	public static binarySearch<T, K>(vector: T[], key: K, comparator: Comparator<T, K>): Optional<T> {
		if (vector.length === 0) {
			return Optional.empty();
		}
		let left = 0;
		let middle = 0;
		let right = vector.length - 1;
		while (left !== right) {
			middle = Math.ceil((left + right) / 2);
			if (0 < comparator(vector[middle], key)) {
				right = middle - 1;
			}
			else left = middle;
		}
		if (comparator(vector[left], key) === 0) {
			return Optional.of(vector[left]);
		}
		else return Optional.empty();
	}
}
